import { Component, Input } from "@angular/core";
import { ProductViewModelBase } from "src/domain/client";

@Component({
  selector: "vw-product-carousel",
  templateUrl: "./product-carousel.component.html",
})
export class ProductCarouselComponent {
  @Input() items: ProductViewModelBase[] = [];
  @Input() title = "";
  @Input() backgroundColor: boolean = false;

  constructor() {}
}
